import React, { useState, useEffect } from "react";
import { database } from "../../firebase";
import { getFirestore, collection, query as queryFirestore, where, orderBy, getDocs } from 'firebase/firestore';
import { onValue, ref, orderByChild, startAfter, onChildAdded, endBefore, query, equalTo } from "firebase/database";
import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, OutlinedInput, Select, Snackbar, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { utils, writeFile } from 'xlsx';
import moment from "moment";
import MuiAlert from '@mui/material/Alert';
import { getCuadrillasOnce } from "../../services/cuadrillasService";
import { getPricesOnce } from "../../services/priceService";
import { getMaterialesOnce } from "../../services/materialsService";
const firestore = getFirestore();

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function DownloadExcel({ open, onCloseModal }) {
    const [alertValidationDate, setAlertValidationDate] = useState('')
    const [snackbarInfo, setSnackbarInfo] = useState({ open: false, text: '', type: 'neutral' })
    const [prices, setPrices] = useState('')
    const [cuadrillas, setCuadrillas] = useState([])
    const [services, setServices] = useState([])
    const [allMaterials, setAllMaterials] = useState([])
    const [idCuadrilla, setIdCuadrilla] = useState(-1);
    const [state, setState] = useState({
        dateTo: null,
        dateFrom: null,
    });
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        // onValue(ref(database, '/precios_new/'), (snapshot) => {
        //     setPrices(Object.values(snapshot.val()));
        // }, {
        //     onlyOnce: true
        // });
        // onValue(ref(database, '/cuadrillas/'), (snapshot) => {
        //     setCuadrillas(Object.values(snapshot.val()))
        // }, {
        //     onlyOnce: true
        // });
        getPricesOnce(setPrices)
        getCuadrillasOnce(setCuadrillas)
        getMaterialesOnce(setAllMaterials)
        const loadServices = async () => {
            try {
                const servicesCollection = collection(firestore, 'servicios');
                const queryServices = queryFirestore(servicesCollection, orderBy('id', 'asc'));
                const snapshot = await getDocs(queryServices);
                setServices(snapshot.docs.map(doc => doc.data()));
            } catch (error) {
                console.error("Error al obtener los datos de servicios:", error);
            }
        }
        loadServices()
    }, [])

    const handleCloseSanckbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarInfo({ text: '', type: 'info', open: false });
    };

    const onChangeDateTo = (value) => {
        const d = new Date(value);
        const isBeforeDate = moment(d).isBefore(moment(new Date()));
        if (isBeforeDate) {
            setState(prevState => ({ ...prevState, dateTo: value }));
            setAlertValidationDate('')
        } else {
            setAlertValidationDate('La fecha debe ser menor o igual a la actual')
        }
    };

    const onChangeDateFrom = (value) => {
        const d = new Date(value);
        const isBeforeDate = moment(d).isBefore(moment(new Date()));
        if (isBeforeDate) {
            setState(prevState => ({ ...prevState, dateFrom: value }));
            setAlertValidationDate('')
        } else {
            setAlertValidationDate('La fecha debe ser menor o igual a la actual')
        }
    };

    const filterValuesServices = (value, id, type) => {
        const newFilter = value?.filter(valor => valor.id === id)
        const valueExist = newFilter?.length > 0
        let valueToReturn = type === 'bool' ? 'NO' : "0";
        if (valueExist) {
            valueToReturn = newFilter[0]?.value === true ? 'SI' : newFilter[0]?.value
        }
        return valueToReturn
    }

    const filterValuesMaterials = (value, id) => {
        const newFilter = value?.filter(valor => valor.id === id);
        const valueExist = newFilter?.length > 0;
        let valueToReturn = valueExist ? newFilter[0]?.value : '';
        return valueToReturn
    }

    const findPriceById = (id) => {
        if (!prices || !Array.isArray(prices)) return null;
        const byField = prices.find(p => p?.id === id);
        if (byField) return byField;
        return prices[id] || null;
    }

    const priceValueServices = (value, id, tipoCliente, horaTrabajo, tipoDia) => {
        const newFilter = value?.filter(valor => valor.id === id)
        const valueExist = newFilter?.length > 0
        const typeValue = valueExist && typeof newFilter[0]?.value === 'boolean';
        let priceService = '';

        if (valueExist) {
            const priceEntry = findPriceById(id);
            const priceHogar = tipoDia === 'Semana'
                ? parseInt(priceEntry?.hogar, 10) || 0
                : parseInt(priceEntry?.feriado_domingo_hogar, 10) || 0;
            priceService = typeValue ? priceHogar : priceHogar * (parseInt(newFilter[0]?.value, 10) || 0);
        }
        return priceService
    }

    const getServiceId = (columnName, servicesList) => {
        const cleanName = columnName.trim().toLowerCase();
        
        if (cleanName.includes("instalacion basica 1p")) return 0;
        if (cleanName.includes("instalacion solo flow")) return 1;
        if (cleanName.includes("instalacion basica 2p")) return 2;
        if (cleanName.includes("media jornada")) return 3;
        if (cleanName.includes("jornal completa")) return 4;
        
        const match = (servicesList || []).find(s => {
            const sName = s.name.toLowerCase();
            if (cleanName.includes("desconexion") && sName.includes("desconexion")) return true;
            if (cleanName.includes("soporte ftth") && sName.includes("soporte fttx")) return true;
            if (cleanName.includes("reinstalacion ftth") && sName.includes("reinstalación")) return true;
            if (cleanName.includes("relevamiento") && sName.includes("relevamiento")) return true;
            return sName === cleanName;
        });
        
        if (match) return match.id;
        
        if (cleanName.includes("soporte ftth")) return 5;
        if (cleanName.includes("reinstalacion ftth")) return 6;
        if (cleanName.includes("relevamiento")) return 7;
        
        return null;
    };

    const buildSheet1 = (orders) => {
        const headers = [
            "Item", "INDICE ", "CONTRATo", "OT", "CONTRATO2", "Cliente", "vacio", "vacio2", "Fecha Asistida", "Tipo OT", "Dia",
            "Instalacion Basica 1P", "Instalacion Solo Flow", "Instalacion Basica 2P (FTTH +FLOW)", "Media Jornada de trabajo - FTTH/Wireless", "Jornal completa de trabajo - FTTH/Wireless",
            "Desconexion FTTX", "vacio4", "Soporte FTTH ", "vacio5", "Reinstalacion FTTH", "Relevamiento ", "vacio6", "vacio7", "vacio8",
            "Cantidad", "Conector SC (Unid)", "Serial ONT",
            "Serial Flow 1", "Serial Flow 2", "Serial Flow 3", "Serial Flow 4",
            "Serial Ext 1", "Serial Ext 2",
            "Numero de Cuadrilla", "Cuadrilla",
            "vacio9", "vacio10",
            "Instalacion Basica 1P9", "Instalacion Solo Flow10", "Instalacion Basica 2P (FTTH +FLOW)11", "Media Jornada de trabajo - FTTH/Wireless12", "Jornal completa de trabajo - FTTH/Wireless13",
            "Desconexion FTTX", "vacio12", "Soporte FTTH 16", "vacio13", "Reinstalacion FTTH18", "Relevamiento 19",
            "vacio14", "vacio15",
            "Total", "Work Order", "Nro Cita", "Usuario"
        ];

        const data = orders.map((order, index) => {
            const getPriceForCol = (colBaseName) => {
                const sId = getServiceId(colBaseName, services);
                return sId !== null ? priceValueServices(order?.services, sId, 'HOME', 'Normal', order?.tipoDia) : '';
            };

            const servicePrices = services.map(s =>
                priceValueServices(order?.services, s.id, 'HOME', 'Normal', order?.tipoDia)
            );
            const total = servicePrices.reduce((sum, v) => sum + (Number(v) || 0), 0);

            return [
                order?.id,
                index + 1, // INDICE
                '', // CONTRATo
                order?.nroOt || '', // OT
                order?.contrato || '', // CONTRATO2
                order?.cliente || '', // Cliente
                '', // vacio
                '', // vacio2
                order?.date ? moment(order.date, "YYYYMMDD").format("DD/MM/YYYY") : '', // Fecha Asistida
                order?.tipoOt || '', // Tipo OT
                order?.tipoDia || '', // Dia
                filterValuesServices(order?.services, getServiceId("Instalacion Basica 1P", services), 'bool'),
                filterValuesServices(order?.services, getServiceId("Instalacion Solo Flow", services), 'bool'),
                filterValuesServices(order?.services, getServiceId("Instalacion Basica 2P (FTTH +FLOW)", services), 'bool'),
                filterValuesServices(order?.services, getServiceId("Media Jornada de trabajo - FTTH/Wireless", services), 'bool'),
                filterValuesServices(order?.services, getServiceId("Jornal completa de trabajo - FTTH/Wireless", services), 'bool'),
                filterValuesServices(order?.services, getServiceId("Desconexion FTTX", services), 'bool'), // Columna Q (index 16)
                '', // vacio4
                filterValuesServices(order?.services, getServiceId("Soporte FTTH ", services), 'bool'),
                '', // vacio5
                filterValuesServices(order?.services, getServiceId("Reinstalacion FTTH", services), 'bool'),
                filterValuesServices(order?.services, getServiceId("Relevamiento ", services), 'bool'),
                '', // vacio6
                '', // vacio7
                '', // vacio8
                '', // Cantidad
                filterValuesMaterials(order?.materials, 16), // Conector SC (Unid) -> ID 16
                order?.serialOnt?.length > 0 ? order.serialOnt[0] : '', // Serial ONT
                order?.serialesFlow?.[0] || '', // Serial Flow 1
                order?.serialesFlow?.[1] || '', // Serial Flow 2
                order?.serialesFlow?.[2] || '', // Serial Flow 3
                order?.serialesFlow?.[3] || '', // Serial Flow 4
                order?.serialesExt?.[0] || '', // Serial Ext 1
                order?.serialesExt?.[1] || '', // Serial Ext 2
                order?.codCuadrilla || '', // Numero de Cuadrilla
                order?.cuadrilla || '', // Cuadrilla
                '', // vacio9
                '', // vacio10
                getPriceForCol("Instalacion Basica 1P"),
                getPriceForCol("Instalacion Solo Flow"),
                getPriceForCol("Instalacion Basica 2P (FTTH +FLOW)"),
                getPriceForCol("Media Jornada de trabajo - FTTH/Wireless"),
                getPriceForCol("Jornal completa de trabajo - FTTH/Wireless"),
                getPriceForCol("Desconexion FTTX"), // Precio Columna Q
                '', // vacio12
                getPriceForCol("Soporte FTTH "),
                '', // vacio13
                getPriceForCol("Reinstalacion FTTH"),
                getPriceForCol("Relevamiento "),
                '', // vacio14
                '', // vacio15
                total,
                order?.workOrder || '',
                order?.nroCita || '',
                order?.user || ''
            ];
        });

        return { headers: [headers], data };
    };

    const buildSheet2 = (orders) => {
        let sortedMaterials = [];
        if (allMaterials && allMaterials.length > 0) {
            sortedMaterials = [...allMaterials].sort((a, b) => (a.id ?? 0) - (b.id ?? 0));
        } else {
            const materialsMap = new Map();
            orders.forEach(order => {
                (order.materials || []).forEach(m => {
                    if (!materialsMap.has(m.id)) {
                        materialsMap.set(m.id, { id: m.id, name: m.name });
                    }
                });
            });
            sortedMaterials = [...materialsMap.values()].sort((a, b) => a.id - b.id);
        }

        const sortedServices = [...services].sort((a, b) => (a.id ?? 0) - (b.id ?? 0));

        const maxFlow = Math.max(0, ...orders.map(o => o.serialesFlow?.length || 0));
        const maxExt = Math.max(0, ...orders.map(o => o.serialesExt?.length || 0));
        const maxConf = Math.max(0, ...orders.map(o => {
            const sc = o.serialesConfigurados;
            if (Array.isArray(sc)) return sc.length;
            if (sc && typeof sc === 'object') return Object.values(sc).flat().length;
            return 0;
        }));

        const maxOntBodega = Math.max(0, ...orders.map(o => o.ontBodega?.length || 0));
        const maxFlowBodega = Math.max(0, ...orders.map(o => o.flowBodega?.length || 0));
        const maxExtBodega = Math.max(0, ...orders.map(o => o.extBodega?.length || 0));

        const headers = [
            "Item", "Nro Formulario", "Departamento", "Work Order", "Nro Cita", "CONTRATO", "OT",
            "Cliente", "CIUDAD", "Dia", "Mes", "Año", "Fecha Asistida", "Dia", "Tipo OT", "Descarga Field Manager",
            ...sortedServices.map(s => s.name),
            ...sortedMaterials.map(m => m.name),
            "Nomenclatura del NAP",
            "Serial ONT", "Cantidad de Decos",
            ...Array.from({ length: maxFlow }, (_, i) => `Serial Flow ${i + 1}`),
            ...Array.from({ length: maxExt }, (_, i) => `Serial Ext ${i + 1}`),
            ...Array.from({ length: maxConf }, (_, i) => `Serial Equipo Configurado ${i + 1}`),
            ...Array.from({ length: maxOntBodega }, (_, i) => `ONT Bodega ${i + 1}`),
            ...Array.from({ length: maxFlowBodega }, (_, i) => `Flow Bodega ${i + 1}`),
            ...Array.from({ length: maxExtBodega }, (_, i) => `Ext Bodega ${i + 1}`),
            "ONT Retirado", "Flow Retirado", "Ext Retirado",
            "Numero de Cuadrilla",
            "Cuadrilla", "Usuario",
            ...sortedServices.map(s => s.name),
            "Total", "Comentarios", "Fecha realización",
        ];

        const data = orders.map(order => {
            const servicePrices = sortedServices.map(s =>
                priceValueServices(order?.services, s.id, 'HOME', 'Normal', order?.tipoDia)
            );
            const total = servicePrices.reduce((sum, v) => sum + (Number(v) || 0), 0);

            const sc = order?.serialesConfigurados;
            const confArray = Array.isArray(sc) ? sc : (sc && typeof sc === 'object' ? Object.values(sc).flat() : []);

            return [
                order?.id,
                order?.nroFormulario || '',
                order?.departamento || '',
                order?.workOrder || '',
                order?.nroCita || '',
                order?.contrato || '',
                order?.nroOt || '',
                order?.cliente || '',
                order?.ciudad || '',
                moment(order?.date, "YYYYMMDD").format("DD"),
                moment(order?.date, "YYYYMMDD").format("MM"),
                moment(order?.date, "YYYYMMDD").format("YYYY"),
                moment(order?.date, "YYYYMMDD").format("DD/MM/YYYY"),
                order?.tipoDia || '',
                order?.tipoOt || '',
                order?.checkField ? 'NO' : '',
                ...sortedServices.map(s => filterValuesServices(order?.services, s.id, 'bool')),
                ...sortedMaterials.map(m => filterValuesMaterials(order?.materials, m.id)),
                '', // Nomenclatura del NAP
                order?.serialOnt?.length > 0 ? order.serialOnt[0] : '',
                order?.serialesFlow?.length || 0,
                ...Array.from({ length: maxFlow }, (_, i) => order?.serialesFlow?.[i] || ''),
                ...Array.from({ length: maxExt }, (_, i) => order?.serialesExt?.[i] || ''),
                ...Array.from({ length: maxConf }, (_, i) => confArray[i] || ''),
                ...Array.from({ length: maxOntBodega }, (_, i) => order?.ontBodega?.[i] || ''),
                ...Array.from({ length: maxFlowBodega }, (_, i) => order?.flowBodega?.[i] || ''),
                ...Array.from({ length: maxExtBodega }, (_, i) => order?.extBodega?.[i] || ''),
                order?.ontRetirado?.length > 0 ? order.ontRetirado[0] : '',
                order?.decoRetirado?.length > 0 ? order.decoRetirado[0] : '',
                order?.extRetirado?.length > 0 ? order.extRetirado[0] : '',
                order?.codCuadrilla || '',
                order?.cuadrilla || '',
                order?.user || '',
                ...servicePrices,
                total,
                order?.comments || '',
                order?.confectionData || '',
            ];
        });

        return { headers: [headers], data };
    };

    const handleExport = (displayTable) => {
        const dataDisplay = idCuadrilla !== -1 ? displayTable?.filter(order => order?.idCuadrilla === idCuadrilla) : displayTable;
        if (dataDisplay.length > 0) {
            const servicesWithoutPrice = services.filter(s => {
                const entry = findPriceById(s.id);
                return !entry || (entry.hogar == null && entry.feriado_domingo_hogar == null);
            });
            if (servicesWithoutPrice.length > 0) {
                const names = servicesWithoutPrice.map(s => `${s.name} (id ${s.id})`).join(', ');
                setSnackbarInfo({
                    open: true,
                    text: `Servicios sin precio cargado: ${names}. Se exportará igual con monto 0.`,
                    type: 'warning'
                });
            }
            const dateNow = moment(new Date()).format("YYYYMMDD");
            const sheet1 = buildSheet1(dataDisplay);
            const sheet2 = buildSheet2(dataDisplay);

            const wb = utils.book_new();
            
            const ws1 = utils.aoa_to_sheet(sheet1.headers);
            utils.sheet_add_aoa(ws1, sheet1.data, { origin: 'A2' });
            utils.book_append_sheet(wb, ws1, 'Resumen');

            const ws2 = utils.aoa_to_sheet(sheet2.headers);
            utils.sheet_add_aoa(ws2, sheet2.data, { origin: 'A2' });
            utils.book_append_sheet(wb, ws2, 'Detalle Completo');

            writeFile(wb, `ordenes-${dateNow}.xlsx`);
        } else {
            setSnackbarInfo({ open: true, text: 'No hay datos para descargar con estos parámetros', type: 'error' })
        }
    }

    const onClickAccept = async () => {
        const ordenesCollection = collection(firestore, 'ordenes');

        const dateFrom = moment(state.dateFrom, "DD/MM/YYYY").format("YYYYMMDD");
        const dateTo = moment(state.dateTo, "DD/MM/YYYY").format("YYYYMMDD");
        const topUserPostsRef = queryFirestore(
            ordenesCollection, orderBy('date', 'asc'),
            where('date', '>=', dateFrom),
            where('date', '<=', dateTo)
        );
        setLoading(true)
        // Ejecutar la consulta
        const querySnapshot = await getDocs(topUserPostsRef);

        if (!querySnapshot.empty) {
            const data = querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            handleExport(data);
        } else {
            handleExport([]);
        }
        // onValue(topUserPostsRef, (snapshot) => {
        //     ordersArray = snapshot.val() ? Object.values(snapshot.val()) : [];
        //     handleExport(ordersArray)
        // }, {
        //     onlyOnce: true
        // });
        setTimeout(() => {
            setLoading(false)
        }, 6000);
        // setOpenModal(false)
    }

    const onChangeSelect = (event, cuadrilla) => {
        const value = cuadrilla.id;
        setIdCuadrilla(value);
    }

    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Ingrese fechas desde y hasta para descargar la planilla"}
                </DialogTitle>
                <DialogContent className="dialog-dates" sx={{ paddingTop: '24px' }}>
                    <LocalizationProvider dateAdapter={AdapterMoment} sx={{ marginRight: '10px' }}>
                        <DatePicker
                            className="date-selector"
                            label="Fecha Desde"
                            inputFormat="DD/MM/YYYY"
                            value={state.dateFrom}
                            onChange={onChangeDateFrom}
                            renderInput={(params) => <TextField {...params} />}
                            sx={{ marginRight: '10px' }}
                        />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                            className="date-selector"
                            label="Fecha Hasta"
                            inputFormat="DD/MM/YYYY"
                            value={state.dateTo}
                            onChange={onChangeDateTo}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                    <FormControl sx={{ width: '83%', margin: '10px 0' }}>
                        <Autocomplete
                            options={cuadrillas}
                            id="disable-clearable"
                            disableClearable
                            onChange={(e, cuadrilla) => onChangeSelect(e, cuadrilla)}
                            getOptionLabel={(option) => option.usuario ? `${option.usuario} - ${option.numero}` : (option.numero || '')}
                            fullWidth
                            renderInput={(params) => (
                                <TextField {...params} label="Cuadrilla" placeholder="Cuadrilla" />
                            )}
                        />
                    </FormControl>
                    {alertValidationDate !== '' && <MuiAlert severity="error">{alertValidationDate}</MuiAlert>}
                </DialogContent>
                <DialogActions>
                    {loading && <CircularProgress />}
                    <Button onClick={onCloseModal}>Cerrar</Button>
                    <Button
                        onClick={onClickAccept}
                        disabled={state.dateFrom === null || state.dateTo === null}
                    >
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={snackbarInfo.open} autoHideDuration={2000} onClose={handleCloseSanckbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={handleCloseSanckbar} severity={snackbarInfo.type} sx={{ width: '100%' }}>
                    {snackbarInfo.text}
                </Alert>
            </Snackbar>
        </>
    );
}
